const state = () => ({
    phone: null,
    password: null,
});

const getters = {
    getReceptionPhone: state => state.phone,
    getReceptionPassword: state => state.password,
};

const actions = {
    // 비회원 정보 저장
    setNonMemberPhone({commit}, phone) {
        commit('SET_PHONE', phone);
    },
    setNonMemberPassword({commit}, password) {
        commit('SET_PASSWORD', password);
    },
};

const mutations = {
    SET_PHONE(state, payload) {
        state.phone = payload;
    },
    SET_PASSWORD(state, payload) {
        state.password = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
